<template>
  <card class="card" title="Zoom Application Credentials">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-6">

            <fg-input type="text"
                      label="Application Key"
                      placeholder=""
                      v-model="user.app_key">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Application Secret"
                      placeholder=""
                      v-model="user.app_secret">
            </fg-input>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="text-center">
          <p-button type="info"
                    round
                    @click.native.prevent="updateProfile">
            Update Application Keys
          </p-button>
        </div>
      </form>
    </div>
  </card>
</template>
<script>
import API from '../../services/api.js'
export default {
  props: ['user'],
  data() {
    return {
      app: {
        app_key:'',
        app_secret:'',
        id: `${localStorage.getItem('userid')}` || null
      }
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
   // this.getAppCredentials()
  },
  methods: {
    updateProfile() {
        this.app.email = this.userLogin.email
        API.post(`/app`,{app: this.user})
        .then(({data}) => {
          this.$notification.open({
            message: "Success",
            description: "Keys updated!",
          });
        })
    }
  }
};
</script>
<style>
</style>
